import React from "react";
import Browse from "../Browse";

export default function BrowsePage() {
  return (
    <div className="container mt-5 pt-5">
      <Browse />
    </div>
  );
}
